import { css, Global } from '@emotion/react'
import { useEffect, useState } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'components/Image/Image'
import { styled } from 'styles/styled'
import { theme, themeUtils } from 'styles/theme'
import 'swiper/css'
import 'swiper/css/pagination'

interface CarouselPhoneProps {
  images: Array<string>
}

const CarouselContainer = styled.div`
  position: relative;
  height: 400px;
  width: auto;
  margin: 12px auto;
  ${themeUtils.maxWidth.md} {
    padding: 0 16px;
  }
`
const CounterContainer = styled.div`
  position: absolute;
  z-index: 12;
  bottom: 10px;
  right: 35px;
  color: ${theme.palette.surface.subdued};
  padding: 2px 5px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
`

function CarouselPhone({ images }: CarouselPhoneProps) {
  const [currentSlide, setCurrentSlide] = useState(1)
  const [totalSlides, setTotalSlides] = useState(images.length)

  useEffect(() => {
    setTotalSlides(images.length)
  }, [images.length])

  return (
    <>
      <Global
        styles={css`
          .swiper-pagination-bullet {
            background: ${theme.palette.surface.subdued} !important;
          }
        `}
      />
      <CarouselContainer>
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex + 1)}
          onInit={(swiper) => setTotalSlides(swiper.slides.length)}
          style={{
            height: '100%',
            width: '100%',
            borderRadius: '16px'
          }}
        >
          {images.map((src, index) => (
            <SwiperSlide key={index} style={{ height: '100%', width: '100%' }}>
              <Image
                alt={`Slide ${index}`}
                priority={index === 0}
                src={src.trim()}
                fill
                sizes="100vw"
                key={index}
                css={css`
                  object-fit: cover;
                `}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <CounterContainer>
          {currentSlide} / {totalSlides}
        </CounterContainer>
      </CarouselContainer>
    </>
  )
}

export default CarouselPhone
